import React, { FC, useState, useEffect } from 'react'
import clsx from 'clsx'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3'
const toolbarButtonHeightClass = 'btn-active-light-primary btn-custom w-50px h-50px w-md-40px h-md-40px transform-270'

const AirButton: FC = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [dragging, setDragging] = useState(false)
  const [relPosition, setRelPosition] = useState({ x: 0, y: 0 })

  useEffect(() => {
    const updatePosition = () => {
      const initialX = window.innerWidth - 70;
      const initialY = window.innerHeight - 70;
      setPosition({ x: initialX, y: initialY });
    };

    updatePosition();

    window.addEventListener('resize', updatePosition);
  
    return () => {
      window.removeEventListener('resize', updatePosition);
    };
  }, []);
  return (
    <div
      className={clsx('d-flex align-items-center position-fixed', toolbarButtonMarginClass)}
      style={{ left: position.x, top: position.y, cursor: dragging ? 'grabbing' : 'grab' }}
    >
      <div
        className={clsx(
          'btn btn-icon btn-active-light-primary btn-custom position-relative',
          toolbarButtonHeightClass
        )}
        id='kt_drawer_chat_toggle'
      >
        <img
          src='/custom/obase-air.png'
          alt='icon'
          className='h-50px w-50px position-absolute'
        />
      </div>
    </div>
  )
}

export { AirButton }